module.exports = __webpack_public_path__ + "static/media/SPRIMAGEN.77c15b5e.png";